(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dna-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dna-wheel-finder')) {
    customElements.define('dna-wheel-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const data = this.querySelector('[data-dna-categories]');
        if (!data) return;
        let brands;
        try { brands = JSON.parse(data.textContent); } catch { return; }
        if (!brands.length) return;
        this.dataset.ready = 'true';
        const brand = this.querySelector('[name="brand"]');
        const design = this.querySelector('[name="design"]');
        const size = this.querySelector('[name="size"]');
        const button = this.querySelector('button');
        const status = this.querySelector('.dna-selection');
        const fill = (select, rows, placeholder) => {
          select.replaceChildren(new Option(placeholder, ''));
          rows.forEach((row, i) => select.add(new Option(row.title, String(i))));
        };
        fill(brand, brands, this.dataset.brandPlaceholder);
        fill(design, [], this.dataset.designPlaceholder);
        fill(size, [], this.dataset.sizePlaceholder);
        const selected = () => {
          const b = brand.value === '' ? null : brands[Number(brand.value)];
          const d = b && design.value !== '' ? b.designs[Number(design.value)] : null;
          const s = d && size.value !== '' ? d.sizes[Number(size.value)] : null;
          return { b, d, s };
        };
        const update = () => {
          const { b, d, s } = selected();
          button.disabled = !b;
          status.textContent = b ? [b, d, s].filter(Boolean).map(row => row.title).join(' → ') : '';
        };
        brand.addEventListener('change', () => {
          const b = brand.value === '' ? null : brands[Number(brand.value)];
          fill(design, b ? b.designs : [], this.dataset.designPlaceholder);
          fill(size, [], this.dataset.sizePlaceholder);
          design.disabled = !b; size.disabled = true; update();
        });
        design.addEventListener('change', () => {
          const { d } = selected();
          fill(size, d ? d.sizes : [], this.dataset.sizePlaceholder);
          size.disabled = !d; update();
        });
        size.addEventListener('change', update);
        this.querySelector('form').addEventListener('submit', event => {
          event.preventDefault();
          const { b, d, s } = selected();
          const target = s || d || b;
          if (target && target.url) window.location.assign(target.url);
        });
        this.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
